import { Typography } from '@vapor/material'
import { useTranslation } from 'react-i18next'

export default function UnsavedChangesTypography({ show }: { show: boolean }) {
  const { t } = useTranslation()
  return (
    <>
      {show && (
        <Typography variant="body" color="var(--MaximumRed)" sx={{ width: '100%' }}>
          <b>{t('commons.there_are_unsaved_changes')}</b>
        </Typography>
      )}
    </>
  )
}
